import { createContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MixpanelWrapper } from '../../components/MixPanelWrapper';
import { getBrokerDetails } from '../../services/broker';
import { Broker } from '../types/quotes';
import { useDispatch, useSelector } from 'react-redux';
import { clearUser } from '../../services/features/authApi/authSlice';
import { useGetBrokerByIdQuery } from '../../services/features/brokerApi/brokerApi';
import { RootState } from '../../store';
import { skipToken } from '@reduxjs/toolkit/dist/query';

// Define the shape of the authentication context object.
export type AuthContextType = {
	user: Broker | null;
};

// Define the initial state for the authentication context.
export const initialState: AuthContextType = {
	user: null,
};

// Create an authentication context using React's createContext.
const AuthContext = createContext<AuthContextType>(initialState);

// Create a component that provides the authentication context to its children.
export const AuthContextProvider = ({ children }: any) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { id: brokerId } = useSelector((state: RootState) => state.authSlice);

	const {
		data: broker,
		isLoading,
		isUninitialized,
	} = useGetBrokerByIdQuery(brokerId ?? skipToken, { skip: !brokerId });

	// Initialize the 'user' state using localStorage if available.
	const [user, setUserProfile] = useState<Broker | null>(() => {
		let userProfile = localStorage.getItem('userProfile');
		if (userProfile) {
			MixpanelWrapper.identify(JSON.parse(userProfile).id);
			return JSON.parse(userProfile);
		}
		return null;
	});

	// const [isAdmin, setIsAdmin] = useState(admin ?? false);

	useEffect(() => {
		if (broker && brokerId) {
			localStorage.setItem('firstName', broker?.firstName ?? '');
			localStorage.setItem('lastName', broker?.lastName ?? '');
			localStorage.setItem('userProfile', JSON.stringify(broker));

			MixpanelWrapper.identify((brokerId ?? '').toString());
			setUserProfile(broker ?? null);
		} else if (!isLoading && !isUninitialized && !brokerId) {
            console.log('Clearing user here');
			MixpanelWrapper.reset();
			dispatch(clearUser());
			setUserProfile(null);
			navigate('/');
		}
	}, [broker, brokerId, isLoading, isUninitialized]);

	// Use 'useEffect' to update the 'user' state and Mixpanel identity on component mount.
	// useEffect(() => {
	// 	let userProfile = localStorage.getItem('userProfile');
	// 	if (userProfile) {
	// 		MixpanelWrapper.identify(JSON.parse(userProfile).id);
	// 		setUserProfile({ ...JSON.parse(userProfile) });
	// 		let admin = localStorage.getItem('isAdmin');
	// 		console.log("localStorage.getItem('isAdmin')", admin);
	// 		setIsAdmin(admin === 'true');
	// 	} else {
	// 		MixpanelWrapper.reset();
	// 		dispatch(clearUser());
	// 		setUserProfile(null);
	// 		setIsAdmin(false);
	// 	}
	// }, []);

	// Function to log in a user and update the 'user' state.
	// const login = async (username: any, password: any) => {
	// 	// Perform the login and handle the response.
	// 	// const userLogin = await loginUser(username, password);
	// 	// if (!('token' in userLogin && 'id' in userLogin)) {
	// 	// 	console.log('here is our error', userLogin);
	// 	// 	setIsAdmin(false);
	// 	// 	localStorage.removeItem('isAdmin');
	// 	// 	return userLogin;
	// 	// } else {
	// 	// 	setIsAdmin(userLogin.admin);
	// 	// 	dispatch(setUser(userLogin));
	// 	// 	// dispatch(setBrokerId(userLogin.id));
	// 	// 	localStorage.setItem('isAdmin', JSON.stringify(userLogin.admin));
	// 	// 	try {
	// 	// 		localStorage.setItem('username', username);
	// 	// 		const broker = await getBrokerDetails(userLogin.id);
	// 	// 		localStorage.setItem('firstName', broker.firstName);
	// 	// 		localStorage.setItem('lastName', broker.lastName);

	// 	// 		localStorage.setItem('userProfile', JSON.stringify(broker));
	// 	// 		MixpanelWrapper.identify(broker.id.toString());
	// 	// 		setUserProfile(broker);
	// 	// 	} catch (error: any) {
	// 	// 		throw new Error(error);
	// 	// 	}
	// 	// }
	// 	// return true;
	// };

	// Function to log out a user and reset the 'user' state.
	// const logout = async () => {
	// 	try {
	// 		await logoutUser();
	// 	} catch (err) {
	// 		console.log('Error logging out', err);
	// 	} finally {
	// 		// Reset localStorage, Mixpanel identity, and navigate to the root path.
	// 		// dispatch(clearUser());
	// 		setUserProfile(null);
	// 		// setIsAdmin(false);
	// 		MixpanelWrapper.reset();
	// 		navigate('/');
	// 	}
	// };

	return (
		// Provide the 'user', 'login', and 'logout' functions to the context consumers.
		// <AuthContext.Provider value={{ user, login, logout, isAdmin }}>
		<AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>
	);
};

export default AuthContext;
